import React from 'react';
import styled from 'styled-components';
import { IEventConditionFieldsFragment } from '../../../utils/apollo/graphqlSchema';
import * as BuilderInfoUI from '../BuilderInfoUI';
import { contentBasePadding } from '../BuilderInfoUI';
import SpecialEventLabel from './SpecialEventLabel';
import EventConditionInfo from './EventConditionInfo';

interface IProps {
  eventConditions: IEventConditionFieldsFragment[];
  isNameAutoGenerated: boolean;
  name: string;
  index: number;
}

const Content = styled(BuilderInfoUI.VerticalRow)`
  ${contentBasePadding};
`;

export default ({
  eventConditions,
  isNameAutoGenerated,
  name,
  index,
}: IProps) => {
  return (
    <BuilderInfoUI.BorderedSection>
      <BuilderInfoUI.BorderedSectionHeader>
        <SpecialEventLabel
          iconName="merge-event-active"
          iconPositiveIndex={index + 1}
        >
          <BuilderInfoUI.InfoLabel $noMargin>
            Merge Event(s)
          </BuilderInfoUI.InfoLabel>
          {!isNameAutoGenerated && (
            <>
              <BuilderInfoUI.VerticalSeparator />
              <BuilderInfoUI.PlainInfo>
                <BuilderInfoUI.InfoLabel>Alias</BuilderInfoUI.InfoLabel>
                <BuilderInfoUI.BorderedInfo>{name}</BuilderInfoUI.BorderedInfo>
              </BuilderInfoUI.PlainInfo>
            </>
          )}
        </SpecialEventLabel>
      </BuilderInfoUI.BorderedSectionHeader>
      <Content>
        {eventConditions.map((eventCondition, eventIndex) => (
          <EventConditionInfo
            key={`merge-event-condition-${index}-${eventIndex}`}
            condition={eventCondition}
            label={'Event(s)'}
            noMarginBottom={true}
          />
        ))}
      </Content>
    </BuilderInfoUI.BorderedSection>
  );
};
